// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown__item.selected[data-v-ba7ca336]{font-weight:400;color:#606266}.albums[data-v-ba7ca336],.drop[data-v-ba7ca336]{cursor:move}.albums[data-v-ba7ca336]{float:left;margin-right:10px;position:relative}.ab[data-v-ba7ca336]{position:absolute;right:-5px;top:-5px}.ab[data-v-ba7ca336],.re[data-v-ba7ca336]{color:#f60;cursor:pointer;font-size:20px;background:#fff;border-radius:50%}.re[data-v-ba7ca336]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
